import React from "react";

const Loader = () => {
  return (
    <div className="loader-layout">
      <div className="custom-spinner"></div>
    </div>
  );
};

export default Loader;
